import { Component, ElementRef, EventEmitter, Output, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fc-dropdown-component',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropdownComponent {
    @Input() disabled: boolean;
    @Output() onOpen = new EventEmitter();
    @Output() onClose = new EventEmitter();

    constructor(private elementRef: ElementRef) {
        this.disabled = false;
    }

    get dropdown(): HTMLElement {
        return this.elementRef.nativeElement.querySelector('.fc-dropdown');
    }

    open() {
        if (this.disabled) {
            return;
        }

        this.dropdown.classList.add('is-active');
        this.onOpen.emit(undefined);
    }

    close() {
        this.dropdown.classList.remove('is-active');
        this.onClose.emit(undefined);
    }

    toggle() {
        if (this.isOpened()) {
            this.close();
        } else {
            this.open();
        }
    }

    isOpened() {
        return this.dropdown.classList.contains('is-active');
    }
}
